import http from '@/http'
const URL = '/admin'

export const login = (payload) => http.post(URL + '/auth/login', payload)
export const logout = (payload) => http.post(URL + '/auth/logout', payload)
export const loadSession = () => http.get(URL + '/settings/me')

export default {
  login,
  logout,
  loadSession
}
